import { useState } from 'react'

const EventForm = ({ event, onSave, onCancel, saving = false }) => {
  const [subject, setSubject] = useState(event?.subject || '')
  const [date, setDate] = useState(event?.scheduledFor?.slice(0, 10) || '')
  const [time, setTime] = useState(event?.scheduledFor?.slice(11, 16) || '')
  const [notes, setNotes] = useState(event?.notes || '')
  const [matter, setMatter] = useState(event?.matter || '')

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!subject.trim() || !date) return

    const scheduledFor = time ? `${date}T${time}:00` : `${date}T00:00:00`
    onSave({
      subject: subject.trim(),
      scheduledFor,
      notes: notes.trim(),
      matter: matter.trim(),
    })
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Subject <span className="text-red-400">*</span>
        </label>
        <input
          type="text"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
          required
          className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm
            text-gray-900 focus:outline-none focus:ring-2 focus:ring-cb-accent/30
            focus:border-cb-accent"
          placeholder="Event subject"
        />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Date <span className="text-red-400">*</span>
          </label>
          <input
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            required
            className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm
              text-gray-900 focus:outline-none focus:ring-2 focus:ring-cb-accent/30
              focus:border-cb-accent"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Time
          </label>
          <input
            type="time"
            value={time}
            onChange={(e) => setTime(e.target.value)}
            className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm
              text-gray-900 focus:outline-none focus:ring-2 focus:ring-cb-accent/30
              focus:border-cb-accent"
          />
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Notes
        </label>
        <textarea
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          rows={3}
          className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm
            text-gray-900 focus:outline-none focus:ring-2 focus:ring-cb-accent/30
            focus:border-cb-accent resize-none"
          placeholder="Optional notes..."
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Matter
        </label>
        <input
          type="text"
          value={matter}
          onChange={(e) => setMatter(e.target.value)}
          className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm
            text-gray-900 focus:outline-none focus:ring-2 focus:ring-cb-accent/30
            focus:border-cb-accent"
          placeholder="Associated matter (optional)"
        />
      </div>

      <div className="flex justify-end gap-3 pt-2">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 text-sm font-medium text-gray-600
            hover:text-gray-800 transition-colors rounded-lg hover:bg-gray-50"
        >
          Cancel
        </button>
        <button
          type="submit"
          disabled={saving || !subject.trim() || !date}
          className="px-4 py-2.5 bg-cb-accent text-white rounded-lg text-sm
            font-medium hover:bg-cb-accent/90 transition-colors shadow-sm
            disabled:opacity-50"
        >
          {saving ? 'Saving...' : (event ? 'Update Event' : 'Create Event')}
        </button>
      </div>
    </form>
  )
}

export default EventForm
